import React from "react";
import { Route } from "react-router-dom";
import Layout from "./Layout";

const LayoutRoute = ({ component: Component, title, ...rest }) => (
  <Route
    {...rest}
    render={(props) => (
      <Layout>
        <Component {...props} title={title} />
      </Layout>
    )}
  />
);

export default LayoutRoute;
